/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from "#client";
import type { Client, RequestConfig, ResponseErrorConfig } from "#client";
import type { OrgOrganizationsDecorationRetrievePathOrgId, OrgOrganizationsDecorationRetrieveStatus200 } from "../types/OrgOrganizationsDecorationRetrieve.ts";

function getOrgOrganizationsDecorationRetrieveUrl(org_id: OrgOrganizationsDecorationRetrievePathOrgId) {
	const res = { method: "GET", url: `/api/org/organizations/${org_id}/decoration/` as const };

	return res;
}

/**
 * @description Декорации организации: сохранённый JSON отдаётся как есть, 404 — если не заведены.
 * {@link /api/org/organizations/:org_id/decoration/}
 */
export async function orgOrganizationsDecorationRetrieve(
	org_id: OrgOrganizationsDecorationRetrievePathOrgId,
	config: Partial<RequestConfig> & { client?: Client } = {},
) {
	const { client: request = client, ...requestConfig } = config;

	const res = await request<OrgOrganizationsDecorationRetrieveStatus200, ResponseErrorConfig<Error>, unknown>({
		method: "GET",
		url: getOrgOrganizationsDecorationRetrieveUrl(org_id).url.toString(),
		...requestConfig,
	});

	return res.data;
}
